<div class="forgot-password my-auto">
  <mat-card class="forgot-password-card my-4">
    <h2 translate>FORGOT_PASSWORD.TITLE</h2>
    <div class="subtitle mb-3" translate>FORGOT_PASSWORD.INSTRUCTIONS</div>
    <mat-card-content>
      <form [formGroup]="forgotPasswordForm" class="forgot-password-form" (ngSubmit)="sendResetMail()">
        <mat-form-field appearance="fill">
          <mat-label translate>LABEL.EMAIL</mat-label>
          <input matInput formControlName="email" />
          @if ((email?.dirty || email?.touched) && email?.errors?.required) {
            <mat-error>
              <span translate>ERROR.EMAIL_REQUIRED</span>
            </mat-error>
          }
          @if ((email?.dirty || email?.touched) && email?.errors?.validateEmail) {
            <mat-error>
              <span translate>ERROR.EMAIL_VALID</span>
            </mat-error>
          }
        </mat-form-field>
        <div class="button-container">
          <button mat-raised-button [disabled]="forgotPasswordForm.invalid" type="submit" color="primary" translate>
            <span translate>FORGOT_PASSWORD.BUTTON</span>
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
